// extracted by mini-css-extract-plugin
export default {"appWrapper":"appWrapper--WNq_y","intlSelect":"intlSelect--hWOqt"};